import { padPx } from './units'

/** @deprecated */
export interface PositionProps<T = number | string> {
	top: T
	right: T
	bottom: T
	left: T
}

/** @deprecated */
interface SymmetricProps {
	vertical: number | string
	horizontal: number | string
}

export type SideProps = PositionProps
export type AllSizeValues = [number, number, number, number] | number[]
export type SymmetricSizeValues = [number, number] | number[]
export type SizeArgs = Partial<PositionProps> | AllSizeValues | number
export type SymmetricArgs = Partial<SymmetricProps> | SymmetricSizeValues

interface CSSSizable {
	all(value: number | number[]): string
	only(options: SizeArgs): string
	symmetric(options: SymmetricArgs): string
	edge(options: Partial<SideProps>): string
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	guess(options: any): string
}

/** @deprecated */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSizeProps(arg: any): arg is Partial<PositionProps> {
	if (!arg) {
		return false
	}
	return ['top', 'left', 'right', 'bottom'].some((side) => arg[side] !== undefined)
}

/** @deprecated */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSymmetricProps(arg: any): arg is Partial<SymmetricProps> {
	if (!arg) {
		return false
	}
	return ['horizontal', 'vertical'].some((side) => arg[side] !== undefined)
}

/** @deprecated */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSizeArray(arg: any): arg is AllSizeValues {
	if (!arg) {
		return false
	}
	return arg instanceof Array && arg.length === 4 && arg.every((v) => v !== undefined)
}

/** @deprecated */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSymmetricArray(arg: any): arg is SymmetricSizeValues {
	if (!arg) {
		return false
	}
	return arg instanceof Array && arg.length === 2 && arg.every((v) => v !== undefined)
}

/** @deprecated */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSymmetricArg(arg: any): arg is Partial<SymmetricProps> | SymmetricSizeValues {
	return isSymmetricArray(arg) || isSymmetricProps(arg)
}

/** @deprecated */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSizeArg(arg: any): arg is Partial<PositionProps> | AllSizeValues {
	return isSizeArray(arg) || isSizeProps(arg)
}

/** @deprecated */
export function genericSizable(property: string): Pick<CSSSizable, 'all' | 'only' | 'symmetric' | 'guess'> {
	return {
		all(value) {
			return `${property}: ${(value instanceof Array ? value : [value]).map(padPx).join(' ')};`
		},
		only(options) {
			const out: string[] = []
			if (isSizeArray(options) || isSymmetricArray(options)) {
				return `${property}: ${options.map(padPx).join(' ')};`
			} else if (isSizeProps(options)) {
				for (const side of ['top', 'right', 'bottom', 'left']) {
					// @ts-expect-error todo if you see this please remove this comment and fix the type error
					const v = options[side]
					// @ts-expect-error todo if you see this please remove this comment and fix the type error
					if (options[side] !== undefined) {
						out.push(`${property}-${side}: ${padPx(v)};`)
					}
				}
			} else if (['number', 'string'].includes(typeof options)) {
				return `${property}: ${padPx(options)};`
			}
			return out.join('\n')
		},
		symmetric(options) {
			const out: string[] = ['0', '0']
			if (isSymmetricArray(options)) {
				return `${property}: ${options.map(padPx).join(' ')};`
			} else {
				if (options.vertical !== undefined) {
					out[0] = padPx(options.vertical)
				}
				if (options.horizontal !== undefined) {
					out[1] = padPx(options.horizontal)
				}
			}
			return `${property}: ${out.join(' ')};`
		},
		guess(options) {
			if (isSizeArg(options)) {
				return this.only(options)
			} else if (isSymmetricArg(options)) {
				return this.symmetric(options)
			}
			return this.all(options)
		},
	}
}

/**
 * @deprecated
 * returns size as object width {width, height}
 * */
export function sizeProps<T = number>(width: T | number | string, height: T | number | string = width) {
	return { width: width as T, height: height as T }
}

/** @deprecated */
export function size(width: number | string, height: number | string = width, important = false) {
	return sizeStyleFromObject(sizeProps(width, height), important)
}

/** @deprecated */
export function sizeStyleFromObject(sz: { width: number | string; height: number | string }, important = false) {
	let out = ''
	for (const k in sz) {
		out += `
			${/* @ts-expect-error todo if you see this please remove this comment and fix the type error */ ''}
			${k}: ${padPx(sz[k])}${important ? ' !important' : ''};
		`
	}

	return out
}

/** @deprecated */
export const padding = genericSizable('padding')
/** @deprecated */
export const margin = genericSizable('margin')
/** @deprecated */
